<template>
    <a class="ruhani-section" href="http://ruh.kz" target="_blank">
			<div class="container">
				<img src="/dist/ruhani-logo.svg" class="logo" height="120" alt="Рухани жаңғыру">
				<div class="text">
					<p class='typedjs'>
						{{tr.ruhani_text}}
					</p>
					<span class="author">
						{{tr.ruhani_text_2}}
					</span>
				</div>
			</div>
		</a>
</template>
<script>
//import Typed from 'typed.js';
export default {
    name: 'ruhani',
    data() {
        return {

        }
    },/*
    mounted() {
        var options = {
            strings: ["", this.tr.ruhani_text],
            typeSpeed: 20
        }

        //var typed = new Typed(".typedjs", options);
    },*/
    computed: {
        tr() { return this.$store.getters.translates; }
    }
}
</script>
<style lang="css" scoped>
.ruhani-section {
    padding: 30px 0;
    /*background-image:url(/dist/ruhani-background.svg);*/
    /*background-image:url(/dist/mp-citation-bg.jpg);*/
    /*color:white;*/
    border: 1px solid lightgrey;
    border-left: none;
    border-right: none;
    cursor: pointer;
    display: block;
    text-decoration: none;

}

.ruhani-section:hover {
    background-color: whitesmoke;
    transition: 0.3s all ease;
}

.ruhani-section img {
    float: left;
    margin-right: 22px;
}

.ruhani-section .text p {
    /*font-family: 'Caveat', cursive;*/
    font-size: 20px;
    padding-left: 221px;
    margin-top: 0;
    text-decoration: none;
    font-weight: 500;
    font-style: italic;
    font-family: 'Merriweather', serif;
    /*text-decoration: underline;*/
    color: black;
    /*display: inline-block;
	vertical-align: middle;*/
}

.ruhani-section .text .author {
    display: block;
    text-align: right;
    margin-top: 10px;
    color: black;
    font-weight: bold;
}

@media(max-width:992px) {
    .ruhani-section img {
        display: block;
        margin: auto;
        float: none;
        margin-right: none;
    }

    .ruhani-section .text p {
        padding-left: 0;
        text-align: center;
        font-size: 14px;
        margin-top: 10px;
    }

    .ruhani-section .author {
        font-size: 14px;
    }
}
</style>